import React, { useState, useEffect } from 'react';
import {
    Card,
    CardContent,
    Typography,
    TextField,
    Button,
    Snackbar,
    withStyles
} from '@material-ui/core';
import ShareIcon from '@material-ui/icons/Share';
import { 
    BITFA_DASHBOARD_URL_DEV, 
    BITFA_DASHBOARD_URL_PROD_V12, 
    BITFA_DASHBOARD_URL_LOCAL 
} from '../constants';

// Style definitions
const styles = (theme) => ({
    container: {
        maxWidth: 800,
        margin: '20px auto',
        padding: theme.spacing.unit * 2,
    },
    title: {
        marginBottom: theme.spacing.unit * 2,
        fontWeight: 'bold',
        color: theme.palette.primary.main,
    },
    description: {
        marginBottom: theme.spacing.unit * 3,
        color: theme.palette.text.secondary,
    },
    linkContainer: {
        display: 'flex',
        alignItems: 'center',
        marginTop: theme.spacing.unit * 2,
    },
    linkField: {
        flex: 1,
        marginRight: theme.spacing.unit,
    },
    copyButton: {
        minWidth: 100,
    },
});

const InvitationLink = ({ classes }) => {
    const [invitationLink, setInvitationLink] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [showSuccess, setShowSuccess] = useState(false);

    // Get user email from localStorage
    useEffect(() => {
        const email = localStorage.getItem('BITFA:DASHBOARD:AUTH:EMAIL');
        if (email) {
            setUserEmail(email);
        }
    }, []);

    // Generate invitation link
    useEffect(() => {
        if (userEmail) {
            // 根据环境变量确定dashboard URL
            let dashboardUrl;
            if (process.env.REACT_APP_ENV === 'production.v12') {
                dashboardUrl = BITFA_DASHBOARD_URL_PROD_V12;
            } else if (process.env.REACT_APP_ENV === 'development') {
                dashboardUrl = BITFA_DASHBOARD_URL_DEV;
            } else {
                dashboardUrl = BITFA_DASHBOARD_URL_LOCAL;
            }
            
            const link = `LOKO is the easiest way to sell Bitcoin at your store, sign up in minutes with this link: ${dashboardUrl}/?formName=signup&referralEmail=${encodeURIComponent(userEmail)}`;
            setInvitationLink(link);
        } else {
            setInvitationLink('');
        }
    }, [userEmail]);

    // Copy link to clipboard
    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(invitationLink);
            setShowSuccess(true);
        } catch (err) {
            console.error('Copy failed:', err);
            // Fallback: use traditional copy method
            const textArea = document.createElement('textarea');
            textArea.value = invitationLink;
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                setShowSuccess(true);
            } catch (fallbackErr) {
                console.error('Fallback copy also failed:', fallbackErr);
            }
            document.body.removeChild(textArea);
        }
    };

    // Close success notification
    const handleCloseSuccess = () => {
        setShowSuccess(false);
    };

    return (
        <div className={classes.container}>
            <Card>
                <CardContent>
                    <div className={classes.linkContainer}>
                        <TextField
                            className={classes.linkField}
                            label="Invitation Link"
                            value={invitationLink}
                            variant="outlined"
                            size="small"
                            multiline
                            rowsMax={4}
                            inputProps={{
                                style: {
                                    wordBreak: 'break-all',
                                    whiteSpace: 'pre-wrap',
                                },
                            }}
                            InputProps={{
                                readOnly: true,
                            }}
                            placeholder={userEmail ? "Generating..." : "Please login to get your invitation link"}
                        />
                        <Button
                            className={classes.copyButton}
                            variant="contained"
                            color="primary"
                            onClick={handleCopyLink}
                            startIcon={<ShareIcon />}
                            disabled={!invitationLink}
                        >
                            Copy
                        </Button>
                    </div>

                    <Snackbar
                        open={showSuccess}
                        autoHideDuration={3000}
                        onClose={handleCloseSuccess}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                        message="Invitation link copied to clipboard!"
                    />
                </CardContent>
            </Card>
        </div>
    );
};

export default withStyles(styles)(InvitationLink);